<template>
  <el-dialog class="restart-rust-detector-task-dialog common-dialog" title="重新运行任务" :visible.sync="showDialog" width="45vh" top="35vh">
    <div class="hint"> 是否重新运行合约【{{ taskInfo.ContractFilename }}】的任务【 {{ taskInfo.ID }} 】？</div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cacel">取 消</el-button>
      <el-button type="primary" @click="makeSure">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'RestartRustDetectorTask',
  props: {
    dialogVisible: Boolean,
    taskInfo: {
      type: Object,
      default: () => {
        return {
          ID: '',
          ContractID: '',
          ContractFilename: '',
          Status: 0,
          CreatedAt: 0,
          StartedAt: 0,
          FinishedAt: 0
        }
      }
    }
  },
  data() {
    return {
      showDialog: false
    }
  },
  watch: {
    dialogVisible: function(val) {
      this.showDialog = val
    },
    showDialog: function(val) {
      this.$emit('update:dialogVisible', val)
    }
  },
  methods: {
    cacel() {
      this.showDialog = false
    },
    makeSure() {
      let self = this
      this.$apis.contractdetector
        .restartRustDetectTask({
          task_id: self.taskInfo.ID
        })
        .then(res => {
          if (res && res.code === 0) {
            self.showDialog = false

            self.$emit('restartSuccess')
            self.$message({
              type: 'success',
              message: '重新运行任务成功!'
            })
          } else {
            if (!res.error) {
              self.$message({
                type: 'error',
                message: '重新运行任务失败!'
              })
            } else {
              const h = self.$createElement
              self.$message({
                type: 'error',
                message: h('p', null, [
                  h('div', { style: 'color: red' }, '重新运行任务失败!'),
                  h('div', { style: 'color: teal' }, res.error)
                ])
              })
            }
          }
          // console.log(res)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.restart-rust-detector-task-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }
  .hint {
    padding: var(--base-size-8) var(--base-size-16);
    margin-bottom: var(--base-size-20);
  }
}
</style>
